// extracted by mini-css-extract-plugin
export default {"table_container":"TableMainResults_table_container__-NUwG","main_table":"TableMainResults_main_table__l9vG+","tabmain_tablele":"TableMainResults_tabmain_tablele__EUEbn"};